import { combineReducers } from 'redux';
import example from './example';
import { connectRouter } from 'connected-react-router';


/**
 * Note: router must be stored as router,
 * as expected by react-router-redux
 */
const createRootReducer = history => {
  return combineReducers({
    router: connectRouter(history),
    example,
  })
};

export default createRootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js